import React from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { useTranslation } from 'react-i18next';

const Chart = ({ data, chartName = 'All', type = 'spline', format, interval }) => {
  const { t } = useTranslation();
  const getChartOptions = (chartData) => {
    return {
      chart: {
        type: type,
        zoomType: 'x'
      },
      title: {
        text: chartData.title
      },
      series: chartData.chartData,
      xAxis: {
        type: 'datetime',
        tickInterval: interval

        // tooltip: {
        //      xDateFormat: format
        // }
      },

      tooltip: {
        xDateFormat: format,
        shared: true
      },
      yAxis: [
        {
          labels: {
            enabled: true
          },
          crosshair: true,
          title: {
            text: `${chartData.value}`
          }
        }
      ]
    };
  };

  const renderHighCharts = () => {
    if (chartName === t('all')) {
      return data.map((item, i) => {
        const options = getChartOptions(JSON.parse(JSON.stringify(item)));
        // Do not show Voltage and Current charts for "All"
        // if (item.title !== 'Voltage' && item.title !== 'Current') {
        return (
          <div key={i}>
            <HighchartsReact
              className='charge-chart'
              key={i}
              highcharts={Highcharts}
              options={options}
            />
          </div>
        );
        // }
      });
    } else {
      const findChart = data.find((item) => item.title === chartName);
      const options = findChart ? getChartOptions(JSON.parse(JSON.stringify(findChart))) : {};
      return <HighchartsReact className='charge-chart' highcharts={Highcharts} options={options} />;
    }
  };

  return renderHighCharts();
};

export default Chart;
